import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const ordersControllerRestUrl = detailServicesPath + '/organizations/order-edges'

export default class OrderEdgeControllerOrganization {
    static async getAll() {
        return axios.get(`${ordersControllerRestUrl}/root`);
    }

    static async getById(orderId) {
        return axios.get(`${ordersControllerRestUrl}/by-order-id?orderId=${orderId}`);
    }

    static async getForModel() {
        return axios.get(`${ordersControllerRestUrl}/for-model`);
    }

    static async getForComposition() {
        return axios.get(`${ordersControllerRestUrl}/for-composition`);
    }

    static async save(data, orderId) {
        return await axios.post(`${ordersControllerRestUrl}?orderId=${orderId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveReserve(data) {
        return await axios.post(`${ordersControllerRestUrl}/reserve`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveModel(data) {
        return await axios.post(`${ordersControllerRestUrl}/model`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveComposition(data) {
        return await axios.post(`${ordersControllerRestUrl}/composition`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderEdgeId) {

        return await axios.delete(`${ordersControllerRestUrl}/${orderEdgeId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(orderEdgeId, data) {
        return await axios.put(`${ordersControllerRestUrl}/${orderEdgeId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async replace(orderEdgeId, materialOrganizationOption) {
        return await axios.put(`${ordersControllerRestUrl}/replace-material/${orderEdgeId}?materialOrganizationOption=${materialOrganizationOption}`, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editReserve(orderEdgeId, data) {
        return await axios.put(`${ordersControllerRestUrl}/reserve/${orderEdgeId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editModel(orderEdgeId, data) {
        return await axios.put(`${ordersControllerRestUrl}/${orderEdgeId}/model`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editComposition(orderEdgeId, data) {
        return await axios.put(`${ordersControllerRestUrl}/${orderEdgeId}/composition`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
